import {Box, Button, Stack, Typography, Divider} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Add01Icon} from "@hugeicons/core-free-icons";
import {CollectionViewToggle} from "../../../../components/CollectionViewToggle";

export const CampaignsHeader = ({onCreate, viewMode, onViewChange}) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1}>
      <Box>
        <Typography variant="h5" fontWeight={600}>Campaigns</Typography>
        <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>
          Manage outbound call campaigns, schedules, and call outcomes
        </Typography>
      </Box>
      <Stack direction="row" alignItems="center" gap={1}>
        <CollectionViewToggle value={viewMode} onChange={onViewChange}/>
          <Divider orientation="vertical" variant="middle" flexItem/>
        <Button
          variant="modal" color="info" size="small"
          sx={{borderRadius: 2, boxShadow: 0}}
          startIcon={<HugeiconsIcon icon={Add01Icon} size={18}/>}
          onClick={onCreate}
        >
          Create campaign
        </Button>
      </Stack>
    </Stack>
  )
}
